"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateServiceError = void 0;
class DuplicateServiceError extends Error {
    constructor(name) {
        super(`DuplicateServiceError: ${name}`);
        Object.setPrototypeOf(this, DuplicateServiceError.prototype);
    }
}
exports.DuplicateServiceError = DuplicateServiceError;
//# sourceMappingURL=DuplicateServiceError.js.map